package or.garden.manager.domain.model

import androidx.compose.ui.graphics.Color
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class PlantedCrop(
    val id: Int,
    val bedId: Int,
    val plantingDate: String, // ISO format: YYYY-MM-DD
    val positionX: Int,
    val positionY: Int,
    val foilId: Int? = null,
    val customWidth: Int? = null,  // For pathways - custom width
    val customHeight: Int? = null, // For pathways - custom height
    val holeSpacing: Int? = null,  // For foils - spacing between holes
    val rows: Int? = null,
    val crop: CropData?,
    @Transient
    var locked: Boolean = false,
    @Transient
    var foilColor: Color? = null
) {
    fun calculatedSize(bedData: BedData) =
        (if (bedData.isHorizontal()) customWidth else customHeight) ?: 1

    fun getHolesCount(bedData: BedData) =
        (calculatedSize(bedData) / (holeSpacing ?: 2)) * (rows ?: 2)
}

@Serializable
data class CreatePlantedCropRequest(
    val cropId: Int,
    val plantingDate: String,
    val positionX: Int,
    val positionY: Int,
    val foilId: Int? = null,
    val tempId: Int? = null,
    val customWidth: Int? = null,  // For pathways - custom width
    val customHeight: Int? = null, // For pathways - custom height
    val holeSpacing: Int? = null,   // For foils - hole spacing
    val rows: Int? = null   // For foils - hole spacing
)

@Serializable
data class UpdatePlantedCropRequest(
    val cropId: Int,
    val plantingDate: String,
    val positionX: Int,
    val positionY: Int,
    val foilId: Int? = null,
    val holeSpacing: Int? = null
)

@Serializable
data class AiSuggestionsData(
    val layoutGuidelines: LayoutGuidelines,
    val rotationPlan: RotationPlan,
    val practicalAdvice: List<String>,
    val fertilizationPlan: FertilizationPlan? = null
)

@Serializable
data class SavePlantedCropsWithSuggestionsRequest(
    val plantedCrops: List<CreatePlantedCropRequest>,
    val aiSuggestions: AiSuggestionsData? = null
)
